import { Selector } from "@ngxs/store";
import { RecordState, RecordStateModel } from "./record.state";

export class RecordSelectors {
    @Selector([RecordState])
    static recordList(state: RecordStateModel) {
        return state.recordListResponse?.record;
    }
    @Selector([RecordState])
    static facesheetList(state: RecordStateModel) {
        return state.facesheetResponse?.record;
    }
    @Selector([RecordState])
    static recordListPendingState(state: RecordStateModel) {
        return state.pending;
    }

    @Selector([RecordState])
    static recordList_Paging(state: RecordStateModel) {
        return state.recordListResponse;
    }

    @Selector([RecordState])
    static displayDate(state: RecordStateModel) {
        const sdate = state.filterSdate;
        const edate = state.filterEdate;
        return !!sdate && !!edate ? { sdate, edate } : null;
    }

    @Selector([RecordState])
    static setting(state: RecordStateModel) {
        return state.setting;
    }

    @Selector([RecordState])
    static listEnv(state: RecordStateModel) {
        return state.listEnv;
    }

    @Selector([RecordState])
    static listEnvXML(state: RecordStateModel) {
        return state.listEnvXML;
    }

    @Selector([RecordState])
    static kirokuSetting(state: RecordStateModel) {
        return state.kirokuSetting;
    }

    @Selector([RecordState])
    static currentCareConneSender(state: RecordStateModel) {
        return state.careconneSendObject;
    }

    @Selector([RecordState])
    static currentCareConneSendersByStudent(state: RecordStateModel) {
        return state.careconneSendObjectsByStudent;
    }
}